// helpers/SelectorHelpers.js

export const getCurrentProjectCode = (selectedProjectId, projects) => {
  if (!selectedProjectId) return null;

  const selectedProject = projects.find((project) => project.id === selectedProjectId);
  return selectedProject ? selectedProject.projectCode : null;
};

export const getCurrentDetailPanelSetting = (selectedView) => {
  return selectedView ? selectedView.detailPanelOn : null;
};

/**
 * Maps projects to the desired format for project selection.
 * @param {Array} projects - Array of project objects.
 * @returns {Array} - The mapped project data.
 */
export const getProjectsSelectData = (projects = []) => {
  if (!Array.isArray(projects)) {
    console.error("getProjectSelectData: 'projects' is not an array.");
    return [];
  }

  return projects.map((project) => ({
    projectToken: project.token,
    projectName: project.name,
    projectCode: project.code,
  }));
};

export const getInitialProject = (projectsData, initialProjectToken) => {
  if (projectsData && Array.isArray(projectsData) && projectsData.length > 0) {
    const defaultProject = projectsData.find((project) => project.token === initialProjectToken);
    return defaultProject;
  }
  return null;
};

export const getSelectedFormAndView = (forms, projectToken, viewLabel) => {
  const selectedForm = forms.find((form) =>
    form.projectToken === projectToken &&
    form.meta.views.some((view) => view.viewLabel === viewLabel)
  );

  let selectedView = null;
  if (selectedForm) {
    selectedView = selectedForm.meta.views.find((view) => view.viewLabel === viewLabel);
  }

  return { selectedForm, selectedView };
};
